/**
 * @generated SignedSource<<7a64d4478114767bade6994e033a5364>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedRecentActivityModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedFavoritesProvider_viewer">;
  readonly " $fragmentType": "HpSharedRecentActivityModule_viewer";
};
export type HpSharedRecentActivityModule_viewer$key = {
  readonly " $data"?: HpSharedRecentActivityModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedRecentActivityModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedRecentActivityModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoritesProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a55fac761370911538d6edca66bb9127";

export default node;
